import {
  FETCH_CENTRE,
  SET_CENTRE,
  SET_IS_LOADING,
  SET_SUBMITTED_SUCCESSFULLY,
  SET_ERROR,
  SET_VALIDATION,
  SET_CONSORTIA,
  SET_CONSORTIUM,
  SET_FETCHING_CONSORTIA,
  SET_CONSORTIA_TOTAL,
  SET_NEXT_PAGE_URL,
  SET_SEARCH_VALUE,
  RESET_STATE,
  ConsortiaManagementTypes,
  SET_FILTER_VALUE,
} from './types';
import { Centre, Consortium } from '@cambridgeassessment/lib-ee-commons';
import { ConsortiaManagementState, seriesType } from '../../types/ConsortiaManagement';

export const fetchCentre = (): ConsortiaManagementTypes => ({
  type: FETCH_CENTRE,
});

export const setCentre = (centre: Centre): ConsortiaManagementTypes => ({
  type: SET_CENTRE,
  payload: { centre },
});

export const setValididation = (validation: ConsortiaManagementState['validation']): ConsortiaManagementTypes => ({
  type: SET_VALIDATION,
  payload: { validation },
});

export const setConsortia = (consortia: Consortium[]): ConsortiaManagementTypes => ({
  type: SET_CONSORTIA,
  payload: { consortia },
});

export const setConsortium = (consortium?: Consortium): ConsortiaManagementTypes => ({
  type: SET_CONSORTIUM,
  payload: { consortium },
});

export const setFetchingConsortia = (value: boolean): ConsortiaManagementTypes => ({
  type: SET_FETCHING_CONSORTIA,
  payload: { value },
});

export const setConsortiaTotal = (count: number): ConsortiaManagementTypes => ({
  type: SET_CONSORTIA_TOTAL,
  payload: { count },
});

export const setNextPageUrl = (url?: string): ConsortiaManagementTypes => ({
  type: SET_NEXT_PAGE_URL,
  payload: { url },
});

export const setSearchValue = (value?: string): ConsortiaManagementTypes => ({
  type: SET_SEARCH_VALUE,
  payload: { value },
});

export const setFilterValue = (value: seriesType): ConsortiaManagementTypes => ({
  type: SET_FILTER_VALUE,
  payload: { value },
});

export const setIsLoading = (isLoading: boolean): ConsortiaManagementTypes => ({
  type: SET_IS_LOADING,
  payload: { isLoading },
});

export const setSubmittedSuccessfully = (value: boolean): ConsortiaManagementTypes => ({
  type: SET_SUBMITTED_SUCCESSFULLY,
  payload: { value },
});

export const setError = (): ConsortiaManagementTypes => ({
  type: SET_ERROR,
});

export const resetState = (): ConsortiaManagementTypes => ({
  type: RESET_STATE,
});

export default {
  fetchCentre,
  setCentre,
  setConsortium,
  setConsortia,
  setFetchingConsortia,
  setConsortiaTotal,
  setValididation,
  setNextPageUrl,
  setFilterValue,
  setSearchValue,
  setIsLoading,
  setSubmittedSuccessfully,
  setError,
  resetState,
};
